export const getVersion = () => "v1.6.7";
